<!--
================================================
Un composant qui affiche la durée total des tâches d'un jour donné
Est affiché dans TaskTimerecordListComp.

Ce composant est une copie de DayDurationComp @since V0.8.0

url d'accès : http://localhost:8080/fr/cronocloud-inc/timeTracking

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <!-- On n'affiche rien si le composant n'est pas prêt ou si le total est 0 (cas un seul pointage en cours -->

    <span v-if="componentIsReady && total != 0" class="TaskDayDurationComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}" v-bind:title="$t('duréeTotaleDuJour')">
        <font-awesome-icon :icon="['fas', 'stopwatch']" class="icon" />
        <span> {{totalFormated}}</span>
    </span>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import TimeMixin from "../mixins/TimeMixin.js";

    export default {
        name: 'TaskDayDurationComp', //utile dans vue dev tool
        mixins: [TimeMixin],
        // components: {},
        props:{
          dayRef: String,  // la S du jour pour lequel il faut calculer la durée (format : 2019-06-06T11:10:29+00:00)
          timerecords: Array // Un array d'objet timerecords dont on veut calculer la durée totale
        } ,
            // ['dayRef'],
        data: function () {
            return {
                total: 0, // la durée totale en millisecondes
                componentIsReady : false, // indique quand le composant est prêt à être afficher
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                // timerecords: state => state.TaskTimerecordListComp.timerecords,
                themeToDisplay: state =>state.app.themeToDisplay

            }),

            //----------------------------------------------
            // other computed props :

            // la durée totale du jour (formatée pour un humain)
            totalFormated: {
                get: function () {
                    return this.formatDuration(this.total,this.$moment,this.$route.params.locale)
                },

            },

        },

        watch: {
            // à chaque fois que les timerecords sont mis à jour, on relance le calcul des durées
            timerecords: function () {
                this.calculateDayDuration()
            }
        },
        methods: {


            /**
             * Calcule la durée total des timerecords pour this.dayRef
             * Ne retourne rien car la valeur est directement enregistrée dans this.total
             */
            calculateDayDuration: function () {
                let self =this;
                let i = 1;
                self.timerecords.forEach(function (tr) {

                    // on ne calcule que les tr qui correspondent à dayRef et on exclut le pointage en cours
                    if (self.isSameDay(tr.timeIn, self.dayRef) && tr.timeOut != null) {
                        let duration = self.calculateDuration(self.$moment,tr.timeIn,tr.timeOut);

                        // au premier tour on ajoute l'objet moment duration au total
                        if(i === 1){
                             self.total = self.$moment.duration(duration);
                        }
                        else { // aux autres tours on additionne
                            self.total = self.total.add(duration);
                        }
                        i++;
                    }

                });

                this.componentIsReady = true;
            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
            this.calculateDayDuration()
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    .TaskDayDurationComp{
        margin-left: 1rem;
        color: $brandFourth;
        font-size: 0.85rem;
        font-weight: normal;
        .icon{
            margin-right: 0;
            /*color: #ccc;*/
        }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode{
        color: #6a6f6f;
        .icon{color:#6a6f6f !important;}
      }
    }
</style>
